documents = {
    docs: [],
    options: []
};


documents.grid = {
    init: () => {
        
    },
    loadNewsGrid: () => {
       
    },
}

documents.select = {
    init: () => {
        documents.docs = window.documentsInView || [];
        documents.options = window.yearsInView || [];

        // Mostrar por defecto el último año del listado
        const defaultYear = (documents.options && documents.options.length) ? documents.options[documents.options.length - 1] : null;

        // Si el <select> no tiene value, se selecciona por texto
        if (defaultYear !== null) {
            $('.tabList').val(defaultYear);
        }

        documents.select.renderDocumentsForYear(defaultYear);

        // bind del cambio de select
        $('.tabList').on('change', function () {
            const selectedYear = $(this).val();
            documents.select.renderDocumentsForYear(selectedYear);
        });
    },

    // obtiene el año "resuelto" desde el objeto documento (usa year_localized si existe)
    getDocumentYear: (doc) => {
        if (doc === null || typeof doc === 'undefined') return null;
        if (doc.year_localized) return String(doc.year_localized);
        const y = doc.year;
        if (!y && y !== 0) return null;
        if (typeof y === 'string' || typeof y === 'number') return String(y);
        if (typeof y === 'object') {
            // intentar obtener primer valor disponible
            const vals = Object.values(y);
            return vals.length ? String(vals[0]) : null;
        }
        return null;
    },

    // renderiza los documentos que coincidan con el año recibido
    renderDocumentsForYear: (year) => {
        const $container = $('.document-list.js-documentList');
        $container.empty();

        if (!year) {
            $container.append('<div class="no-results">No hay documentos</div>');
            return;
        }

        const pattern = $('.js-documentPattern').first();
        if (!pattern.length) return;

        const matched = documents.docs.filter(doc => {
            const docYear = documents.select.getDocumentYear(doc);
            return String(docYear) === String(year);
        });

        if (!matched.length) {
            $container.append('<div class="no-results">No hay documentos para ' + year + '</div>');
            return;
        }

        matched.forEach(doc => {
            const $clone = pattern.clone();
            $clone.removeClass('js-documentPattern').show();

            // enlaces y contenido (proteger contra undefined)
            const filePath = doc.filePath || (doc.file && doc.file.path) || '#';
            const imgSrc = doc.image || '';
            const title = doc.nameToShow || doc.name || '';
            const metadata = doc.metadata || '';
            const locale = window.locale;

            console.log('data', doc, locale, window.locale);

            $clone.find('a.js-view-pdf.img-document').attr('href', filePath);
            $clone.find('a.js-view-pdf.img-document img').attr('src', imgSrc[locale]);
            $clone.find('.title a.js-view-pdf').attr('href', filePath).text(title);
            $clone.find('.title').attr('title', title);
            $clone.find('.download').parent('a').attr('href', filePath);
            $clone.find('.download .info').text(metadata);

            $container.append($clone);
        });
    }

}

documents.init = () => {
    documents.select.init();
};

documents.binds = () => {
    //news.binds();
};

$(document).ready( () => {
    documents.binds();
    documents.init();
});